import {
  EvaluationFilter,
  listEvaluations,
} from '@/data/services/evaluationServices';

export const evaluationQueries = {
  all: ['evaluations'] as const,

  list: (filters: EvaluationFilter = {}) => ({
    queryKey: [...evaluationQueries.all, 'list', { filters }] as const,
    queryFn: () => listEvaluations(filters),
  }),

  listInfinite: (filters: EvaluationFilter = {}) => ({
    queryKey: [
      ...evaluationQueries.list(filters).queryKey,
      'infinite',
    ] as const,
    queryFn: (ctx: { pageParam?: number }) =>
      listEvaluations({ ...filters, pageNumber: ctx.pageParam }),
  }),
};
